import React, { Component } from 'react';
import { connect } from 'react-redux';
import Transition from 'react-transition-group/Transition';
import { every, capitalize, union, difference } from 'lodash';
import { Icon, Typography, Button, TextField } from 'rmwc';
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop,
} from 'rmwc/Dialog';
import { DrawerContent } from 'rmwc/Drawer';
import { Card, CardPrimary, CardTitle, CardSupportingText } from 'rmwc/Card';
import { Text } from '../../components/Text';
import DatePickerControl from '../../components/controls/DatePickerControl';
import PhoneNumberControl from '../../components/controls/PhoneNumberControl';
import CheckboxListControl from '../../components/controls/CheckboxListControl';
import { RightDrawer, DrawerFooter, DrawerFlexGrow } from '../../components/ModuleDrawer/RightDrawer';
import ValidatedField, { validationHandler, PRESENCE } from '../../components/util/ValidatedField';
import { scheduleAppointment } from '../../actions/dashboardActions';
import { Advisor, ADVISORS } from './Advisor';
import SpeakWithHarbor from './SpeakWithHarbor';
import FindIndependentAdvisor from './FindIndependentAdvisor';

const Error = ({ error }) => (error ? <div style={{ color: 'red' }}>{error}</div> : null);

class ScheduleAdvisor extends Component {
  static defaultProps = {
    advisor: 'william',
  };

  state = {
    date: null,
    phone_number: null,
    scheduledAppointment: false,
    errors: {},
    selectedTopics: ['fees', 'taxes', 'social_security'],
  };

  constructor(props) {
    super(props);
    this.onValidate = validationHandler.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    if (!every(this.state.validated)) return;
    this.props.dispatch(scheduleAppointment(this.state)).then(response => {
      this.setState({ scheduledAppointment: true });
    });
  }

  onClose() {
    this.setState({ scheduleAppointment: false });
    this.props.onClose();
  }

  onChange(event) {
    const update = {};
    update[event.target.name] = {
      value: event.target.value,
    };
    this.setState(Object.assign({}, this.state, update));
  }

  onTopicChange = (option, isChecked) => {
    let { selectedTopics } = this.state;
    if (isChecked) {
      selectedTopics.push(option);
    } else {
      selectedTopics = selectedTopics.filter(item => item !== option);
    }
    this.setState({ selectedTopics });
  };

  render() {
    const { advisor, withHarbor, match, history, rootUrl } = this.props;
    const { scheduledAppointment, date, phone_number, errors } = this.state;

    const firstName = capitalize(advisor);
    const advisorData = ADVISORS[advisor];

    return (
      <DrawerFlexGrow>
        <DrawerContent>
          <Text className="text-center" use="subtitle1">
            {withHarbor
              ? 'Get a free 30-minute plan review with a registered investment advisor.'
              : 'Speak with a top-rated independent advisor to give you a second opinion on your plan.'}
          </Text>
          <div style={{ width: 500, margin: '1rem auto' }}>
            <Advisor advisor={advisor} hideSchedule className="mb-3" />

            <Card className="mb-3">
              <CardPrimary>
                <Text use="headline6" className="mb-0">
                  What {firstName} will help you with
                </Text>
              </CardPrimary>
              <CheckboxListControl
                spec={{
                  field_type: 'multiple_choice',
                  options: ['fees', 'taxes', 'social_security'],
                  option_data: {
                    fees: {
                      label: 'Investment Fees',
                      description: 'Minimize your fees while still getting good returns',
                    },
                    taxes: {
                      label: 'Taxes on Investments',
                      description: 'Minimize taxes in retirement.',
                    },
                    social_security: {
                      label: 'Social Security',
                      description: 'Getting the most out of Social Security for you',
                    },
                  },
                }}
                values={this.state.selectedTopics}
                onChange={this.onTopicChange}
              />
            </Card>

            {advisor === 'william' && (
              <Card className="mb-3">
                <CardPrimary>
                  <Text use="headline6">Contact {firstName} directly</Text>
                </CardPrimary>
                <CardSupportingText>
                  <div>
                    <Text use="body1">
                      <a href="tel:8442153380">(844) 215-3380</a>
                    </Text>
                  </div>
                  <a href="mailto:william@harborplan.com">{advisor}@harborplan.com</a>
                </CardSupportingText>
              </Card>
            )}

            <Card>
              <CardPrimary>
                <Text use="headline6">Have {firstName} call you</Text>
              </CardPrimary>
              <CardSupportingText>
                <div className="mb-4">
                  <Text use="body1" className="mb-0">
                    When would you like to schedule your call?
                  </Text>
                  <ValidatedField
                    tag={DatePickerControl}
                    name="date"
                    placeholder="Date & Time"
                    value={date}
                    onValidate={this.onValidate}
                    setDefaultValue={false}
                    validators={[PRESENCE]}
                    onChange={this.onChange}
                  />
                </div>
                <div>
                  <Text use="body1">Whats the best number to reach you at?</Text>
                  <div className="mt-2">
                    <ValidatedField
                      tag={PhoneNumberControl}
                      label="Phone Number"
                      name="phone_number"
                      value={phone_number}
                      validators={[PRESENCE]}
                      onValidate={this.onValidate}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <br />
                <Text use="caption">We'll send you a reminder before the call.</Text>
                <div className="mt-3">
                  <Button raised onClick={this.onSubmit} theme="secondary-bg on-secondary">
                    Schedule
                  </Button>
                </div>
              </CardSupportingText>
            </Card>
          </div>

          {withHarbor ? (
            <FindIndependentAdvisor onClick={() => history.push('/dashboard/indepedent-advisor')} />
          ) : (
            <SpeakWithHarbor onClick={() => history.push('/dashboard/review-plan')} />
          )}

          <ScheduledDialog open={scheduledAppointment} onClose={this.onClose} />
        </DrawerContent>
        <DrawerFooter>
          <Button onClick={() => history.push(rootUrl)} theme="primary-bg" raised>
            Back
          </Button>
        </DrawerFooter>
      </DrawerFlexGrow>
    );
  }
}

const ScheduledDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogSurface>
      <DialogHeader>
        <DialogHeaderTitle>Your request is confirmed!</DialogHeaderTitle>
      </DialogHeader>
      <DialogBody>
        <Typography className="d-block mb-2" use="body1">
          You will receive an e-mail shortly with the details of your request and our response.
        </Typography>
        <Typography use="body1">In the meantime, feel free to continue using the planner!</Typography>
      </DialogBody>
      <DialogFooter>
        <DialogFooterButton accept raised theme="secondary-bg on-secondary">
          Back to Planner
        </DialogFooterButton>
      </DialogFooter>
    </DialogSurface>
    <DialogBackdrop />
  </Dialog>
);

export default connect()(ScheduleAdvisor);
